import { useQuery } from 'react-query';

import { errorHandler } from 'App/utils';
import UserService from 'App/services/UserService';

function useFetchUserBranchDetails() {
    return useQuery(['userBranchDetails'], () => UserService.getBranches(), {
        onError: errorHandler,
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchUserBranchDetails;
